import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

export default function TaskFilters({ filterType, onChange }) {
  return (
    <ToggleButtonGroup
      value={filterType}
      exclusive
      onChange={(event, value) => {
        onChange(value || "");
      }}
      aria-label="task filter"
      sx={{ marginBottom: 2 }}
    >
      <ToggleButton value="dueToday" aria-label="due today">
        Due Today
      </ToggleButton>

      <ToggleButton value="overdue" aria-label="overdue">
        Overdue
      </ToggleButton>

      <ToggleButton value="highPriority" aria-label="high priority">
        High Priority
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
